module.exports = __webpack_public_path__ + "static/media/develop-qr.afae64ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/develop-qr.png
// module id = 714
// module chunks = 21